import { withInstall } from '@fx-front-framework/utils/with-install'
import VPyramidChart from './src/index.vue'

export const FxVPyramidChart = withInstall(VPyramidChart)
export default FxVPyramidChart

export * from './src/types'
